/**
 * Decodificação das entidades HTML que o backend produz ao escapar `message`
 * (TMS-7223 — escape duplo).
 *
 * O backend aplica `e()` ao motivo da NSTech e ao `num_controle` da pré-fatura porque o
 * fallback do Simplert (`ReturnApi`) renderiza `message` por `v-html`. O modal do bloqueio
 * renderiza por interpolação (`{{ }}`), que escapa de novo: sem decodificar, o operador via
 * `&amp;` literal e o texto copiado para o chamado saía escapado.
 *
 * **Só decodifica, nunca interpreta HTML.** O resultado é texto puro e deve ser exibido por
 * interpolação — nunca por `v-html`. Por isso não há `innerHTML`, `DOMParser` nem
 * `textarea` aqui: um mapa fixo de cinco entidades, aplicado em uma única passada
 * (`&amp;lt;` vira `&lt;`, e não `<`).
 *
 * Sem `?.` nem `??`: o toolchain do isend-frontend não os compila.
 */
const ENTIDADES = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#039;": "'",
  "&#39;": "'",
};

const PADRAO = /&(?:amp|lt|gt|quot|#0?39);/g;

/**
 * @param {*} valor
 * @returns {string} texto sem as entidades do escape do backend; vazio para nulo
 */
export function decodificarEntidadesHtml(valor) {
  if (valor == null || valor === "") {
    return "";
  }

  return String(valor).replace(PADRAO, (entidade) => ENTIDADES[entidade]);
}
